import { OnboardingEventId } from '@thoughtspot/onboarding-event-service';
import {
    TourChainActionType,
    TourChainStep,
} from './checklist-tour-steps.util';

export const getSpotterChatTourChain = (
    taskId: string,
    t: (key: string, params?: Record<string, unknown>) => string,
): TourChainStep[] | null => {
    switch (taskId) {
        case OnboardingEventId.SPOTTER_CHAT_ASK_QUESTION:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_conv-assist-send-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.askQuestion.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.askQuestion.content',
                            ),
                            disableBeacon: true,
                            placement: 'bottom-end',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotter.askQuestion.buttonText',
                    ),
                    afterAction: {
                        selector: '[data-tour-id="tour_conv-assist-send-btn"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    condition: () =>
                        !document.querySelector(
                            '[data-testid="error-message"]',
                        ),
                },
            ];

        case OnboardingEventId.SPOTTER_CHAT_PREVIEW_DATA:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_worksheet-action-menu-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.checkData.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.checkData.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-start',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotter.checkData.buttonText',
                    ),
                    afterActions: [
                        {
                            selector:
                                '[data-tour-id="tour_worksheet-action-menu-btn"]',
                            type: TourChainActionType.CLICK,
                        },
                        {
                            selector: '[id="preview-data-btn-action-menu"]',
                            type: TourChainActionType.CLICK,
                        },
                    ],
                    dismissOnAfterClick: true,
                },
            ];

        case OnboardingEventId.SPOTTER_CHAT_RESEARCH_MODE:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_chat-mode-research-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.researchMode.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.researchMode.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-start',
                        },
                    ],
                    readyTarget: '[data-tour-id="tour_chat-mode-research-btn"]',
                    doneButtonText: t(
                        'checklistTour.discoverSpotter.researchMode.buttonText',
                    ),
                    afterAction: {
                        selector:
                            '[data-tour-id="tour_chat-mode-research-btn"]',
                        type: TourChainActionType.CLICK,
                    },
                },
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_conv-assist-send-btn"]',
                            title: t(
                                'checklistTour.discoverSpotter.researchMode.sendQuestion.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.researchMode.sendQuestion.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-end',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotter.researchMode.sendQuestion.buttonText',
                    ),
                    afterAction: {
                        selector: '[data-tour-id="tour_conv-assist-send-btn"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                    condition: () =>
                        !document.querySelector(
                            '[data-testid="error-message"]',
                        ),
                },
            ];

        case OnboardingEventId.SPOTTER_CHAT_CONNECT_TOOLS:
            return [
                {
                    steps: [
                        {
                            target:
                                '[data-tour-id="tour_chat-connectors-button"]',
                            title: t(
                                'checklistTour.discoverSpotter.connectApps.title',
                            ),
                            content: t(
                                'checklistTour.discoverSpotter.connectApps.content',
                            ),
                            disableBeacon: true,
                            placement: 'top-end',
                        },
                    ],
                    doneButtonText: t(
                        'checklistTour.discoverSpotter.connectApps.buttonText',
                    ),
                    afterAction: {
                        selector:
                            '[data-tour-id="tour_chat-connectors-button"]',
                        type: TourChainActionType.CLICK,
                    },
                    dismissOnAfterClick: true,
                },
            ];

        default:
            return null;
    }
};
